// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Register form container 
 * Reference: 1105x491 at 1536x864 screen
 * 1105 / 1536 = 71.94vw
 * 491 / 864 = 56.83vh
 */
.register-form_container__fTHpu {
  position: absolute;
  /* Centered horizontally and vertically */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  /* Responsive dimensions based on 1536x864 */
  width: 71.94vw;
  height: 56.83vh;
  max-width: 1105px;
  max-height: 491px;
  min-width: 320px;

  /* No background - transparent */
  /* Less top padding to move heading to top */
  padding: clamp(10px, 1.5vw, 20px) clamp(25px, 3vw, 45px) clamp(25px, 3vw, 45px);

  /* Allow button to be visible */
  overflow: visible;
  z-index: 2;
}

/* Heading section - absolutely positioned at top of form */
.register-form_heading__j924i {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* Prevent wrapping - keep ! on same line */
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: clamp(8px, 1.2vw, 20px);
  padding-left: clamp(25px, 3vw, 45px);
}

h1 {
  font-size: clamp(32px, 4vw, 55px);
  color: #FFAB00;
  font-family: "FreckleFace", serif;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
}

/* Input grid wrapper - positioned below heading */
.register-form_wrapper__TELR- {
  display: grid;
  place-items: start;
  width: 100%;
  /* Grid layout for desktop */
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, auto);
  /* Row gap between inputs */
  row-gap: clamp(25px, 4vh, 45px);
  /* Triple column gap */
  column-gap: clamp(75px, 9vw, 150px);
  padding: 0 clamp(10px, 1.5vw, 20px);
  /* Space for the heading above - tripled */
  margin-top: clamp(120px, 18vh, 200px);
}

.register-form_wrapper__TELR->div {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.register-form_usernameStatus__RfeI0 {
  min-height: 18px;
  margin: -8px 0 0 0;
  font-size: 13px;
  font-weight: 800;
}

.register-form_availableStatus__FzKF3 {
  color: #9DD102;
}

.register-form_pendingStatus__W3nZP {
  color: #FFAB00;
}

/* Form positioning */
.register-form_form__aiZSJ,
.register-form_newForm__J0dOz {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: inherit;
  transition: transform 0.6s ease, opacity 0.6s ease;
  display: flex;
  flex-direction: column;
}

.register-form_form__aiZSJ.register-form_fadeOut__Tqzre {
  transform: translateY(-100%);
  opacity: 0;
}

.register-form_newForm__J0dOz {
  transform: translateY(100%);
  animation: register-form_slideIn__pwKcB 0.6s ease forwards;
}

@keyframes register-form_slideIn__pwKcB {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

/* Tablet adjustments */
@media (max-width: 1024px) {
  .register-form_container__fTHpu {
    width: 85vw;
    height: auto;
    min-height: 450px;
    max-width: 700px;
  }

  .register-form_wrapper__TELR- {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 15px;
    column-gap: 30px;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .register-form_container__fTHpu {
    width: 92vw;
    height: auto;
    min-height: 500px;
    max-width: 450px;
    padding: 20px;
  }

  .register-form_heading__j924i {
    /* Keep nowrap to prevent ! from going to next line */
    flex-wrap: nowrap;
    justify-content: center;
    gap: 6px;
  }

  .register-form_wrapper__TELR- {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 10px;
    column-gap: 0;
    /* Reduce space from heading in mobile */
    margin-top: 50px;
  }

  .register-form_wrapper__TELR->div {
    align-items: center;
  }

  h1 {
    font-size: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/components/register-form.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;EACT,QAAQ;EACR,gCAAgC;;EAEhC,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;;EAEhB,gCAAgC;EAChC,4CAA4C;EAC5C,+EAA+E;;EAE/E,+BAA+B;EAC/B,iBAAiB;EACjB,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,SAAS;AACX;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;EAC3B,+BAA+B;EAC/B,sBAAsB;EACtB,mCAAmC;EACnC,mCAAmC;EACnC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0DAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,qDAAqD;IACrD,iBAAiB;IACjB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,aAAa;IACb,aAAa;IACb,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Register form container \n * Reference: 1105x491 at 1536x864 screen\n * 1105 / 1536 = 71.94vw\n * 491 / 864 = 56.83vh\n */\n.container {\n  position: absolute;\n  /* Centered horizontally and vertically */\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n  /* Responsive dimensions based on 1536x864 */\n  width: 71.94vw;\n  height: 56.83vh;\n  max-width: 1105px;\n  max-height: 491px;\n  min-width: 320px;\n\n  /* No background - transparent */\n  /* Less top padding to move heading to top */\n  padding: clamp(10px, 1.5vw, 20px) clamp(25px, 3vw, 45px) clamp(25px, 3vw, 45px);\n\n  /* Allow button to be visible */\n  overflow: visible;\n  z-index: 2;\n}\n\n/* Heading section - absolutely positioned at top of form */\n.heading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  /* Prevent wrapping - keep ! on same line */\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  gap: clamp(8px, 1.2vw, 20px);\n  padding-left: clamp(25px, 3vw, 45px);\n}\n\nh1 {\n  font-size: clamp(32px, 4vw, 55px);\n  color: #FFAB00;\n  font-family: \"FreckleFace\", serif;\n  font-weight: 400;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0;\n}\n\n/* Input grid wrapper - positioned below heading */\n.wrapper {\n  display: grid;\n  place-items: start;\n  width: 100%;\n  /* Grid layout for desktop */\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(3, auto);\n  /* Row gap between inputs */\n  row-gap: clamp(25px, 4vh, 45px);\n  /* Triple column gap */\n  column-gap: clamp(75px, 9vw, 150px);\n  padding: 0 clamp(10px, 1.5vw, 20px);\n  /* Space for the heading above - tripled */\n  margin-top: clamp(120px, 18vh, 200px);\n}\n\n.wrapper>div {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.usernameStatus {\n  min-height: 18px;\n  margin: -8px 0 0 0;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.availableStatus {\n  color: #9DD102;\n}\n\n.pendingStatus {\n  color: #FFAB00;\n}\n\n/* Form positioning */\n.form,\n.newForm {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  padding: inherit;\n  transition: transform 0.6s ease, opacity 0.6s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.form.fadeOut {\n  transform: translateY(-100%);\n  opacity: 0;\n}\n\n.newForm {\n  transform: translateY(100%);\n  animation: slideIn 0.6s ease forwards;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n/* Tablet adjustments */\n@media (max-width: 1024px) {\n  .container {\n    width: 85vw;\n    height: auto;\n    min-height: 450px;\n    max-width: 700px;\n  }\n\n  .wrapper {\n    grid-template-columns: repeat(2, 1fr);\n    row-gap: 15px;\n    column-gap: 30px;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .container {\n    width: 92vw;\n    height: auto;\n    min-height: 500px;\n    max-width: 450px;\n    padding: 20px;\n  }\n\n  .heading {\n    /* Keep nowrap to prevent ! from going to next line */\n    flex-wrap: nowrap;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .wrapper {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    row-gap: 10px;\n    column-gap: 0;\n    /* Reduce space from heading in mobile */\n    margin-top: 50px;\n  }\n\n  .wrapper>div {\n    align-items: center;\n  }\n\n  h1 {\n    font-size: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `register-form_container__fTHpu`,
	"heading": `register-form_heading__j924i`,
	"wrapper": `register-form_wrapper__TELR-`,
	"usernameStatus": `register-form_usernameStatus__RfeI0`,
	"availableStatus": `register-form_availableStatus__FzKF3`,
	"pendingStatus": `register-form_pendingStatus__W3nZP`,
	"form": `register-form_form__aiZSJ`,
	"newForm": `register-form_newForm__J0dOz`,
	"fadeOut": `register-form_fadeOut__Tqzre`,
	"slideIn": `register-form_slideIn__pwKcB`
};
export default ___CSS_LOADER_EXPORT___;
